import script from "./ProgramVersionTargetsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionTargetsForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionTargetsForm.vue?vue&type=style&index=0&id=57727f38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57727f38"]])

export default __exports__